module.exports = __webpack_public_path__ + "img/Photo_4__Fourth_Canal_979_79_1.c77feaea.jpg";